import React from 'react';
import styles from './SectionTitle.module.scss';

function SectionTitle(props) {
    const { className = '', children } = props;

    return <h3 className={[className, styles.SectionTitle].join(' ')}>{children}</h3>;
}

export default SectionTitle;
